import styled from 'styled-components';
import { units, typeStyle, color } from '@m/alchemy-ui/theme';

export const SettingsTitle = styled.h1`
  ${typeStyle('headerXL')};
  color: ${color('contrast', { palette: 'illustrativeSteelGrey' })};
  margin-bottom: ${units(3)};
  text-align: center;
  text-transform: uppercase;
`;
